import { render, staticRenderFns } from "./createNxOrder.vue?vue&type=template&id=f119a060&scoped=true"
import script from "./createNxOrder.vue?vue&type=script&lang=js"
export * from "./createNxOrder.vue?vue&type=script&lang=js"
import style0 from "./createNxOrder.vue?vue&type=style&index=0&id=f119a060&prod&scoped=true&lang=css"
import style1 from "./createNxOrder.vue?vue&type=style&index=1&id=f119a060&prod&lang=css"
import style2 from "./createNxOrder.vue?vue&type=style&index=2&id=f119a060&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f119a060",
  null
  
)

export default component.exports